import { SUPPORTED_LOCALE_CODES } from "./supportedLocales";

const normalizeCode = (code) => {
  if (!code) return null;
  const lower = String(code).toLowerCase();
  if (lower === "ua") return "uk";
  if (lower.startsWith("zh")) return "zh-Hans";
  if (lower.startsWith("uk")) return "uk";
  if (lower.startsWith("de")) return "de";
  if (lower.startsWith("ru")) return "ru";
  if (lower.startsWith("en")) return "en";
  return null;
};

const isSupported = (code) => SUPPORTED_LOCALE_CODES.includes(code);

export default function detectLanguage() {
  const cached = normalizeCode(localStorage.getItem("app_lang"));
  if (cached && isSupported(cached)) return cached;

  const tgLang = normalizeCode(window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code);
  if (tgLang && isSupported(tgLang)) return tgLang;

  const navLang = normalizeCode(navigator?.languages?.[0] || navigator?.language);
  if (navLang && isSupported(navLang)) return navLang;

  return "en";
}

